import moment from "moment";
import { api } from "../../../../helper/api";
import { mConstants } from "../../../../helper/constants";
import helper from "../../../../helper/helper";
import { IoPagination } from "../../../../helper/pagination";
import { MComment } from "../../product/entity/product.model";
import { User } from "../../user/entity/user.model";
import { userService } from "../../user/service/user.service";
import {
  Assignment,
  AssignmentFilter,
  Task,
  TaskFilter,
  TaskUI,
} from "../entity/task.model";

async function getTasks(taskFilter: TaskFilter): Promise<IoPagination<TaskUI>> {
  let tasks: IoPagination<TaskUI> = await api.post(
    `${mConstants.TASK_URL}/tasks/admin`,
    taskFilter
  );

  tasks.content.forEach((task) => (task.date = moment(task.date)));

  return tasks;
}

async function getAssignment(uuid: string): Promise<Assignment> {
  let assignment: Assignment = await api.get(
    `${mConstants.TASK_URL}/assignments/${uuid}`
  );

  let users: User[] = await userService.getUsers(assignment.username);

  assignment.assignedMoment = moment(assignment.assignedDate);
  assignment.createdMoment = moment(assignment.createdDate);
  assignment.user = users.at(0);

  return assignment;
}

async function getAssignmentComments(uuid: string): Promise<MComment[]> {
  let comments: MComment[] = await api.get(
    `${mConstants.ORDER_URL}/assignments/${uuid}/comments`
  );

  for (const comment of comments) {
    if (comment.commentUploads) {
      for (const commentUpload of comment.commentUploads) {
        commentUpload.file = await helper.getImageUrl(commentUpload.filePath);
      }
    }
  }

  return comments;
}

async function getAssignments(
  assignmentFilter: AssignmentFilter
): Promise<IoPagination<Assignment>> {
  let assignments: IoPagination<Assignment> = await api.get(
    `${mConstants.TASK_URL}/assignments`,
    {
      params: assignmentFilter,
    }
  );

  assignments.content.forEach((assignment, index) => {
    assignment.index = index + 1;
    assignment.assignedMoment = moment(assignment.assignedDate);
    assignment.createdMoment = moment(assignment.createdDate);
  });

  return assignments;
}

async function getTask(uuid: string): Promise<TaskUI> {
  let task: Task = await api.get(`${mConstants.TASK_URL}/tasks/${uuid}/detail`);

  for (const stall of task.stalls) {
    let beforeImage = await helper.getImageUrl(stall.beforeImagePath);
    let afterImage = await helper.getImageUrl(stall.afterImagePath);

    stall.beforeImageFile = beforeImage ?? "";
    stall.afterImageFile = afterImage ?? "";
  }

  return { ...task, date: moment(task.date) };
}

function editTask(task: Task): Promise<void> {
  return api.put(`${mConstants.TASK_URL}/tasks`, task);
}

function addAssignment(assignment: Assignment): Promise<Assignment> {
  assignment.assignedDate = assignment.assignedMoment.toDate();
  
  if (assignment.user) {
    assignment.username = assignment.user?.username;
  }
  
  return api.post(`${mConstants.TASK_URL}/assignments`, assignment);
}

function editAssignment(assignment: Assignment): Promise<Assignment> {
  assignment.assignedDate = assignment.assignedMoment.toDate();

  if (assignment.user) {
    assignment.username = assignment.user?.username;
  }

  return api.put(`${mConstants.TASK_URL}/assignments`, assignment);
}

function addAssignmentComment(comment: MComment) {
  return api.post(`${mConstants.ORDER_URL}/assignments/comment`, comment);
}

export const taskService = {
  getTasks,
  getTask,
  editTask,
  getAssignments,
  getAssignment,
  getAssignmentComments,
  addAssignmentComment,
  editAssignment,
  addAssignment
};
